import React from 'react'
import { OurAppsBreadcrumbBar } from '../../../our-apps-breadcrumb-bar'
import CallToActionSection from '../../../call-to-action-section'
import { FeatureSection } from './feature-section'
import { AboutSection } from './about-section'
import { LabProductImage } from '../../../product-image/lab-product-image'

export default function Lab() {
  return (
    <>
      <OurAppsBreadcrumbBar title="Lab" productImage={<LabProductImage />} />

      <AboutSection />

      <CallToActionSection />

      <FeatureSection />
    </>
  )
}
